import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactInfoSectionComponent } from './contact-info-section.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  declarations: [
    ContactInfoSectionComponent
  ],
  exports: [
    ContactInfoSectionComponent
  ]
})
export class ContactInfoSectionModule { }



// WEBPACK FOOTER //
// ./src/app/contact-info-section/contact-info-section.module.ts